import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import DocumentRepositoryAccountListPageUI from './DocumentRepositoryAccountListPageUI'
class DocumentRepositoryAccountListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountList: null,
      filteredAccountList: null,
      searchFilter: '',
      copyToClipboardText: null,
    }
  }

  render() {
    return (
     <DocumentRepositoryAccountListPageUI
        context={this.props.context}
        onRowClick={this.onRowClick}
        errorList={this.state.errorList}
        accountList={this.state.accountList}
        filteredAccountList={this.state.filteredAccountList}
        onRefreshClick={this.onRefreshClick}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAllAccounts(context, context.filter)
  }

  getAllAccounts(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts`,
      cacheKey: CacheKeys.Accounts(context.session.userId, stp),
      callback: this.getAllAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { stp: stp === 'stp' ? true : false })
  }

  getAllAccountsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.AccountsFilter())
    let filters = filtersStr ? JSON.parse(filtersStr) : {}
    this.applyFilters(response.accountList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  }

  onRowClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-row-id')
    window.location.href = `/su/documentRepository/accounts/${accountId}/loans`
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.accountList, searchFilter)
  }

  applyFilters(accountList, searchFilter, errorList) {
    let filteredList = accountList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(acc =>
        acc.accountName.toLocaleLowerCase().includes(searchFilter) ||
        (acc.businessName && acc.businessName.toLocaleLowerCase().includes(searchFilter)) ||
        acc.assignedUserName && acc.assignedUserName.toLocaleLowerCase().includes(searchFilter)
      )
    }

    this.setState({
      accountList: accountList,
      filteredAccountList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.AccountsFilter(), JSON.stringify(filters))
  }

  onRefreshClick = (noBusy) => {
    CacheManager.removeObject(CacheKeys.Accounts(this.props.context.session.userId, this.props.context.filter))
    if (noBusy === 'noBusy')
      this.getAllAccounts(this.props.context, this.props.context.filter)
    else
      this.setState({ accountList: null, errorList: null },
        this.getAllAccounts(this.props.context, this.props.context.filter)
      )
  }
}

export default DocumentRepositoryAccountListPageSF